(function($, undefined) {
	
	'use strict';
	var currPage;
    var profile;
    
    var selectProfile = function(){
        var id = $(this).attr("data-profile-id");
        $(".link-profile-invitation input[name=id]").val(id);
        
        
    };
    
	var init = function (page) {
		currPage = $(page);
        
        profile = $(".invitation-choice-profiles .items-list-one-item-ctn");
        profile.on("click", selectProfile);
	};
	
    	
	$(window).on("load",function(){
        init();
    });
	
})(jQuery);